/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem9Dialog extends Serenity.Extensions.GridEditorDialog<PsAdvPromoItem9Row> {

        // static from: string;
        protected getFormKey() { return PsAdvPromoItem9Form.formKey; }
        // protected getIdProperty() { return PsAdvPromoItem9Row.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoItem9Row.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoItem9Row.nameProperty; }
        protected getService() { return PsAdvPromoItem9Service.baseUrl; }
        // protected getDeletePermission() { return PsAdvPromoItem9Row.deletePermission; }
        // protected getInsertPermission() { return PsAdvPromoItem9Row.insertPermission; }
        // protected getUpdatePermission() { return PsAdvPromoItem9Row.updatePermission; }

        protected form = new PsAdvPromoItem9Form(this.idPrefix);

        private pass: string
        public cpp: string
        public thiscp: string
        public thislucp: string

        public get Pass(): string { return this.pass }
        set Pass(value: string) { this.pass = value; }

        constructor() {
            super();
            this.form.EndBillPmType.change(e => {
                this.endbilltype();
                // console.log(Q.toId(this.form.EndBillPmType.value))
                let orderNo = this.form.EndBillPmType.value
                if (!Q.isEmptyOrNull(orderNo)) {

                    this.form.CouponTypeLookup.value = null;

                    // pass value into lookup editor and update items
                    this.form.CouponTypeLookup.myId = orderNo;
                    this.form.CouponTypeLookup.updateItems();

                    // select first lookup item after changing
                    if (this.form.CouponTypeLookup.items && this.form.CouponTypeLookup.items.length > 0) {
                        // Serenity.EditorUtils.setValue(this.form.DocNo, this.form.DocNo.items[0].id);
                    }


                }

            });


            this.form.CouponTypeLookup.changeSelect2(e => {
                this.lookupcoupon()

            });


            this.form.PluCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.PluCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = "1"
                    this.form.StyleCode.value = null
                    this.form.CatCode.value = null
                    this.form.SubCat1Code.value = null
                    this.form.SubCat2Code.value = null
                    this.form.BrandCode.value = null
                    this.form.SupplCode.value = null
                }
                if (Fg = null) {
                    // this.form.ListFg.value = "0"
                }
            });
            this.form.StyleCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.StyleCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = "0"
                    this.form.PluCode.value = null
                }

            });
            this.form.CatCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.CatCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = "0"
                    this.form.PluCode.value = null
                }

            });
            this.form.SubCat1Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat1Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = "0"
                    this.form.PluCode.value = null
                }

            });
            this.form.SubCat2Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat2Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = "0"
                    this.form.PluCode.value = null
                }

            });
            this.form.SupplCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.SupplCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = "0"
                    this.form.PluCode.value = null
                }

            });
            this.form.BrandCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.BrandCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = "0"
                    this.form.PluCode.value = null
                }

            });

            this.form.PmExtCode.changeSelect2(e => {
                let ex = Q.toId(this.form.PmExtCode.value)
                let gp = Q.toId(this.form.PmGroupId.value)
                this.form.PmId.value = ex + gp;
            });
            

            this.form.FreeLpFg.changeSelect2(e => {
                this.FreeLpFg()
            });

            this.form.ListFg.changeSelect2(e => {
                this.ListFgCheck()
            });

        }







        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            let newitem: Serenity.ToolButton =
            {
                title: "เพิ่ม&ใช้ข้อมูลเดิม",
                hint: "add and new [alt+s]",
                separator: false,
                cssClass: "button-addandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: () => {
                    var s = this.Checkbeforsave();
                    if (s) {

                    }

                    else {
                        Q.confirm('ยืนยันการเพิ่ม'
                            + "\r\n" + "โดยคงค่าข้อมูลเดิม และ Step no.+1"
                            , () => {

                                // e.preventDefault();
                                this.saveAndNew();
                                // this.FreeLpFgcheck();
                                this.ListFgCheck();
                                this.endbilltypecheck();

                            });
                    }
                }
            };
            buttons.push(newitem);
            let newitem2: Serenity.ToolButton =
            {
                title: "เพิ่ม&สร้างใหม่",
                hint: "add and clear [alt+a]",
                separator: false,
                cssClass: "button-addandclear",
                icon: "fa fa-save",
                hotkey: 'alt+a',
                onClick: (e) => {

                    var s = this.Checkbeforsave();
                    if (s) {

                    }

                    else {

                        e.preventDefault();
                        Q.confirm('ยืนยันการเพิ่ม และสร้างรายการใหม่ทั้งหมด'
                            + "\r\n" + "โดย ล้างรายการที่ป้อนทั้งหมด", () => {

                                this.saveAndclear();
                                // this.FreeLpFgcheck();
                                this.ListFgCheck();
                                this.endbilltypecheck();
                                // this.dialogClose();
                            });
                    }
                }
            };
            buttons.push(newitem2);



            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );
            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            if (f.PmStepNo == null) {
                var pmstep = f.PmStepNo.value;
            } else {
                var pmstep = f.PmStepNo.value + 1;
            }
            let Fg = Number(this.form.EndBillPmType.value)
            if (Fg == 2) {

                this.thiscp = "D" + this.form.CouponType.value
                this.thislucp = this.form.CouponTypeLookup.value
            }
            if (Fg == 3) {

                this.thiscp = "C" + this.form.CouponType.value
                this.thislucp = this.form.CouponTypeLookup.value

            }
            this.save((response) => {
                let ent: PsAdvPromoItem9Row = {
                    PmGroupId: f.PmGroupId.value,
                    PmId: f.PmId.value,
                    PmType: f.PmType.value,
                    PmExtCode: f.PmExtCode.value,
                    PmStepNo: pmstep,
                    PmDesc: f.PmDesc.value,

                    // ItemType: Number(f.ItemType.value),
                    NpcsOrBundlePrice: f.NpcsOrBundlePrice.value,
                    EndBillPmType: Number(f.EndBillPmType.value),
                    AssortFg: Number(f.AssortFg.value),
                    DiscPc: f.DiscPc.value,
                    DiscAmt: f.DiscAmt.value,
                    FreeLpFg: Number(f.FreeLpFg.value),
                    CouponTypeLookup: f.CouponTypeLookup.value,
                    CouponType: f.CouponType.value,
                    CouponAgeDay: f.CouponAgeDay.value,
                    CouponGiftDesc: f.CouponGiftDesc.value,

                    ListFg: Number(f.ListFg.value),
                    PluCode: f.PluCode.value,
                    StyleCode: f.StyleCode.value,
                    BrandCode: f.BrandCode.value,
                    CatCode: f.CatCode.value,
                    SubCat1Code: f.SubCat1Code.value,
                    SubCat2Code: f.SubCat2Code.value,
                    SupplCode: f.SupplCode.value
                };
                this.loadEntity(ent);


                let Fg = Number(f.EndBillPmType.value)
                if (Fg == 2 || Fg == 3) {
                    this.form.CouponTypeLookup.myId = Fg.toString();
                    this.form.CouponTypeLookup.updateItems();
                    if (!Q.isEmptyOrNull(this.thiscp)) {
                        this.form.CouponTypeLookup.myId = this.thiscp;
                        this.thiscp = null;
                    }

                }
            });

        }
        private saveAndclear() {
            let e = this.entity; let f = this.form;
            // if (e.SkuCode == null) {
            //     e.SkuCode = f.SkuCode.value;

            // }
            this.save((response) => {
                let ent: PsAdvPromoItem9Row = {
                    PmGroupId: e.PmGroupId,
                    PmType: e.PmType

                };
                this.loadEntity(ent);


            });

        }



        protected afterLoadEntity() {
            super.afterLoadEntity();


            if (this.isNew()) {
                this.form.PmGroupId.value = this.pass
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, true);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, true);
            }

            else {


                let Fg = Number(this.form.EndBillPmType.value)
                if (Fg == 2) {

                    this.thiscp = "D" + this.form.CouponType.value
                    this.thislucp = this.form.CouponTypeLookup.value
                }
                if (Fg == 3) {

                    this.thiscp = "C" + this.form.CouponType.value
                    this.thislucp = this.form.CouponTypeLookup.value

                }
                console.log(this.thiscp + "thiscp" + this.thislucp + "thislucp")
                this.endbilltypecheck();
                this.ListFgCheck();
            }

        }

        private ListFgCheck() {
            let ex = Q.toId(this.form.ListFg.value)
            if (ex == 2) {
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, false);
                this.form.PluCode.value = null
            }
            if (ex == 1) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.PluCode, false);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
            }
            if (ex == 0) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
                this.form.PluCode.value = null
            }
        }

        private lookupcoupon() {
            let Fg = Q.toId(this.form.EndBillPmType.value)
            let lg: string = this.form.CouponTypeLookup.value

            // console.log(lg)
            this.form.CouponType.value = LookupAvPromoCouponTypesRow.getLookup().itemById[lg].CouponType
            this.cpp = LookupAvPromoCouponTypesRow.getLookup().itemById[lg].CouponType
            let ag = this.cpp
            // console.log(this.form.CouponType.value)
            console.log(ag + "คุปอง")
            if (Fg == 2) {
                let x = InitialData.PsDiscCouponTypeRow.getLookup().itemById[ag].DiscCouponValueType;
                console.log(x + "x")
                if (x == 1) {
                    this.form.FreeLpFg.value = "2"
                    this.form.DiscPc.value = null
                    this.form.DiscAmt.value = InitialData.PsDiscCouponTypeRow.getLookup().itemById[ag].DiscCouponValue;
                }
                if (x == 2) {
                    this.form.FreeLpFg.value = "1"
                    this.form.DiscAmt.value = null
                    this.form.DiscPc.value = InitialData.PsDiscCouponTypeRow.getLookup().itemById[ag].DiscCouponValue;
                }
            }
            if (Fg == 3) {
                this.form.DiscAmt.value = InitialData.PsCashCouponTypeRow.getLookup().itemById[ag].CashCouponValue;
            }
            else {

            }
        }

        private FreeLpFg() {
            let Fg = Q.toId(this.form.FreeLpFg.value)
            if (Fg == "1") {
               
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
              

            }
            if (Fg == "2") {
              
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, false);               

            }

        }

        private endbilltype() {
            let Fg = Q.toId(this.form.EndBillPmType.value)

            
            if (Fg == "1") {
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, true);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, false);
                this.form.FreeLpFg.value = "1"
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, true);
                this.form.CouponType.value = null
                this.form.DiscAmt.value = null
                this.form.CouponAgeDay.value = null
                this.form.CouponGiftDesc.value = null

            }
            if (Fg == "2") {

                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, false);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, true);
                this.form.FreeLpFg.value = null
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, false);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, false);
                this.form.DiscPc.value = null
                this.form.DiscAmt.value = null
                // this.form.CouponAgeDay.value = null
                // this.form.CouponGiftDesc.value = null
                if (!Q.isEmptyOrNull(this.thiscp)) {
                    this.form.CouponTypeLookup.myId = this.thiscp;
                    this.thiscp = null;
                }

            }
            if (Fg == "3") {
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, false);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, true);
                this.form.FreeLpFg.value = "2"
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, false);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, false);
                this.form.DiscPc.value = null
                this.form.DiscAmt.value = null
                if (!Q.isEmptyOrNull(this.thiscp)) {
                    this.form.CouponTypeLookup.myId = this.thiscp;
                    this.thiscp = null;
                }
            }
            if (Fg == "4") {
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, true);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, false);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, false);
                this.form.DiscPc.value = null
                this.form.DiscAmt.value = null
                this.form.CouponType.value = null
                this.form.FreeLpFg.value = null
            }
        }

        private endbilltypecheck() {
            let Fg = Q.toId(this.form.EndBillPmType.value)
            console.log(Fg + "endbill")

            if (Fg == "1") {
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, true);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, false);
                // this.form.FreeLpFg.value = "1"
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, true);

                // this.form.CouponType.value = null
                // this.form.DiscAmt.value = null
                // this.form.CouponAgeDay.value = null
                // this.form.CouponGiftDesc.value = null

            }
            if (Fg == "2") {
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, false);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, true);
                // this.form.FreeLpFg.value = null
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, false);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, false);


            }
            if (Fg == "3") {
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, false);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, true);
                // this.form.FreeLpFg.value = "2"
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, false);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, false);


            }
            if (Fg == "4") {
                Serenity.EditorUtils.setReadOnly(this.form.CouponTypeLookup, true);
                Serenity.EditorUtils.setReadOnly(this.form.FreeLpFg, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                Serenity.EditorUtils.setReadOnly(this.form.CouponAgeDay, false);
                Serenity.EditorUtils.setReadOnly(this.form.CouponGiftDesc, false);

            }
        }

        private Checkbeforsave() {

            if (this.form.EndBillPmType.value == "1" && this.form.FreeLpFg.value == "1" && this.form.DiscPc.value == null) {
                Q.warning("โปรด ใส่ส่วนลด");
                return true
            }
            else  if (this.form.EndBillPmType.value == "1" && this.form.FreeLpFg.value == "2" && this.form.DiscAmt.value == null) {
                Q.warning("โปรด ใส่ส่วนลด");
                return true
            }

            else if (this.form.EndBillPmType.value == "2" && this.form.CouponTypeLookup.value == null) {
                Q.warning("โปรด เลือกคูปองส่วนลด");
                return true
            }

            // else if (this.form.EndBillPmType.value == "2" && this.form.CouponTypeLookup.value == null) {
            //     Q.warning("โปรด ใส่ราคาส่วนลด");
            //     return true
            // }
            else if (this.form.EndBillPmType.value == "3" && this.form.CouponTypeLookup.value == null) {
                Q.warning("โปรด เลือกคูปองเงินสด");
                return true
            }
            else if (this.form.EndBillPmType.value == "4" && this.form.CouponGiftDesc.value == null) {
                Q.warning("โปรด ใส่ข้อความแลกของกำนัล");
                return true
            }
            else {
                if (this.form.ListFg.value == "1" && this.form.PluCode.value == "") {
                    Q.warning("โปรด เลือกสินค้า")
                    return true
                }
                else if (this.form.ListFg.value == "2" &&
                    this.form.StyleCode.value == "" && this.form.CatCode.value == ""
                    && this.form.SubCat1Code.value == "" && this.form.SubCat2Code.value == ""
                    && this.form.BrandCode.value == "" && this.form.SupplCode.value == "") {
                    Q.warning("โปรด ระบุเกณฑ์สินค้า")
                    return true
                }
                else {
                    return false
                }
            }





        }

    }
}